import * as React from "react";
import { HostSystemItemView } from "@tlc/ls2pac/dto/HostSystemItemView";
import { LSResultItemBookjacket } from "../search/ls/LSResultItem/LSResultItemBookjacket";
import { LSResultItemLayout } from "../search/ls/LSResultItem/LSResultItemLayout";
import { LoansInfoContainer } from "./LoansDueDate";
import { Box, Chip, Typography } from "@mui/material";
import { LSResultItemTitle } from "../search/ls/LSResultItem/LSResultItemTitle";
import { LSResultItemAuthor } from "../search/ls/LSResultItem/LSResultItemAuthor";
import { RatingHighContrast } from "../../rate-and-review/RatingHighContrast";
import { LSSerialIssueInformation } from "./LSSerialIssueInformation";
import { LSResultItemReadingLevelDisplay } from "../search/ls/LSResultItem/LSResultItemReadingLevelDisplay";
import { GenreDisplay } from "./GenreDisplay";
import { LSResultItemSeries } from "../search/ls/LSResultItem/LSResultItemSeries";

export const LoanItem = ({ loan }: { loan: HostSystemItemView }) => {
  // const { translate } = useLanguage();
  const { resource, title, author, enumeration, chronology } = loan;
  return (
    <LSResultItemLayout
      titleComponent={
        resource ? (
          <LSResultItemTitle resource={resource} />
        ) : (
          <Typography component="h3" variant="h6" flex={1}>
            {title}
          </Typography>
        )
      }
      bookjacketComponent={
        <LSResultItemBookjacket
          {...(loan.resource
            ? { resource: loan.resource }
            : { title: loan.title })}
        />
      }
      checkboxComponent={undefined}
      actionsComponent={undefined}
      authorComponent={
        <LSResultItemAuthor shortAuthor={resource?.shortAuthor || author} />
      }
    >
      {/* Format label and rating */}
      {resource && (
        <Box display="flex" alignItems="center" gap={2}>
          {resource.format && (
            <Box>
              <Chip variant="outlined" label={resource.format} />
            </Box>
          )}

          <RatingHighContrast
            value={resource.ratingInformation?.average}
            readOnly
            precision={0.5}
          />
        </Box>
      )}
      <LSResultItemSeries resource={resource} />
      <LSSerialIssueInformation
        chronology={chronology}
        enumeration={enumeration}
      ></LSSerialIssueInformation>
      <LSResultItemReadingLevelDisplay resource={resource} />
      <GenreDisplay loan={loan} />
      <LoansInfoContainer loanItem={loan} />
    </LSResultItemLayout>
  );
};
